// @flow
import React from 'react';
import GlobalModal from '../UI/GlobalModal';

type Props = {
  errorTitle: ?string,
  errorCode?: number | null,
  acknowledgeErrorAction: () => void,
  noOverflow?: boolean,
  errorInfo: string
};

const GlobalErrorModal = ({
  errorTitle,
  acknowledgeErrorAction,
  errorInfo,
  errorCode = null,
  noOverflow = false
}: Props) => {
  if (!errorTitle) return null;

  return (
    <GlobalModal
      title={errorTitle}
      isOpen={errorTitle !== null}
      onClose={acknowledgeErrorAction}
      onConfirmationClick={acknowledgeErrorAction}
      hasConfirmationButton
      buttonCTA="Got it"
      noOverflow={noOverflow}
    >
      {errorCode ? (
        <p>
          If you believe this to be an error with our system, please get in
          contact with our customer happiness team quoting error:{' '}
          <code>{errorCode}</code>
        </p>
      ) : null}
      {errorInfo ? (
        <p>{errorInfo}</p>
      ) : (
        <p>
          Please refresh the page and try again, or contact customer support if
          the problem persists.
        </p>
      )}
    </GlobalModal>
  );
};

export default GlobalErrorModal;
